import React from 'react';
import { Navigate } from 'react-router-dom';
import { useAuth } from '../../contexts/AuthContext';

function ProtectedRoute({ children, requireAdmin = false }) {
  const { currentUser, loading } = useAuth();

  // Show nothing while checking auth status
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-screen">
        <div className="animate-spin rounded-full h-12 w-12 border-b-2 border-blue-900"></div>
      </div>
    );
  }

  // Not logged in - redirect to login
  if (!currentUser) {
    return <Navigate to="/login" replace />;
  }

  // Logged in but requires admin role
  if (requireAdmin && currentUser.role !== 'admin') {
    return <Navigate to="/player" replace />;
  }

  // All checks passed - render the protected component
  return children;
}

export default ProtectedRoute;
